function isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
}


(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();

  // Blogg functions
  $(".sidebar .widget_nav_menu h4, .sidebar .widget_categories h4").addClass('fa fa-angle-down');
  $(".sidebar .widget_nav_menu h4, .sidebar .widget_categories h4").on("click", function(){
    if(windowWidth < 980) {
      $(this).next().slideToggle();
    }
  });

  function cookieAccept(){
    $('.cookie').hide();
    $('.cookie').remove();
    localStorage.accepted='1';
  }

	/* Document ready functions */
	$(document).ready(function (){

		// Apply style to a if touch device
    if (isTouchDevice()) {
        $('a').addClass('mobile');
    }
    else {
      $('a').removeClass('mobile');
    }

    if(localStorage.accepted === undefined) {
      $('.cookie').fadeIn(300);
    }
    else {
      $('.cookie').hide();
      $('.cookie').remove();
    }
    $(".cookieBtn").on("click", function() {
      cookieAccept();
    });

    $(".enquiry-btn, .bv-online-widget-wrapper p span").on("click", function() {
      $(".online-btn").removeClass("active");
      $(".enquiry-btn").addClass("active");
      $(".tb-conference-form-wrapper").addClass("active");
      $(".bv-online-widget-wrapper").removeClass("active");
    });
    $(".online-btn, .online-btn a, .tb-conference-form-wrapper p span").on("click", function() {
      $(".enquiry-btn").removeClass("active");
      $(".online-btn").addClass("active");
      $(".bv-online-widget-wrapper").addClass("active");
      $(".tb-conference-form-wrapper").removeClass("active");
    });

	});

	$(window).resize(function () {

		// Get Window Width and Height on resize
		windowWidth = $(window).outerWidth();
		windowHeight = $(window).height();

	});

})(jQuery);
